import grapesjs from "grapesjs";
export default grapesjs.plugins.add(
  "plugin-presentation-component",
  (editor, opts = {}) => {
    let componentOptions = opts;

    let pluginAttributes = {
      blocks: "plugin-presentation",

      // Default style
      defaultStyle: true,
      // Date input type, eg, 'date', 'datetime-local'
      dateInputType: "date",

      // Countdown class prefix
      pluginClssfx: "plugin-presentation",

      // Countdown label
      labelCountdown: "Countdown",

      // Countdown category label
      labelCountdownCategory: "Extra",

      // Days label text used in component
      labelDays: "days",

      // Hours label text used in component
      labelHours: "hours",

      // Minutes label text used in component
      labelMinutes: "minutes",

      // Seconds label text used in component
      labelSeconds: "seconds",
    };

    // Load defaults
    for (let name in pluginAttributes) {
      if (!(name in componentOptions))
        componentOptions[name] = pluginAttributes[name];
    }

    // Add components
    //  loadComponents(editor, componentOptions);

    //  // Add components
    // loadBlocks(editor, componentOptions);

    const domComponent = editor.DomComponents;
    const defaultType = domComponent.getType("default");
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;
    const sfx = componentOptions.pluginClssfx;

    domComponent.addType(componentOptions.blocks, {
      model: defaultModel.extend(
        {
          defaults: Object.assign({}, defaultModel.prototype.defaults, {
            droppable: true,
            draggable: true,
            resizable: false,
            attributes: { 
              presentationTitle: 'TÍTULO DE LA PRESENTACIÓN', 
              presentationDescription: 'lorem ipsum', 
              presentationImage: '',
              presentationText: '',
            },
            traits: [
              {
                label: "Titulo",
                name: "presentationTitle",
              },
              {
                label: "Descripción",
                name: "presentationDescription",
              },
              {
                label: "Imagen",
                name: "presentationImage",
              },
              {
                label: "Texto Principal",
                name: "presentationText",
              },
            ]
          }),
        },
        {
          isComponent(el) {
            if (
              el.getAttribute &&
              el.getAttribute("data-gjs-type") == componentOptions.blocks
            ) {
              return { type: componentOptions.blocks };
            }
          },
        }
      ),

      view: defaultView.extend({
        init: function () {
          
        },
        onRender() {
          // What the user see in the canvas is totally up to you
          // it can be a simple image as a placeholder or
          // you can make it as much close to the original markup
          const attrs = this.model.getAttributes();
          const style = componentOptions.defaultStyle
          ? `<style>
          .${sfx}{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            align-content: center;
            background: url(https://firebasestorage.googleapis.com/v0/b/sapiencia-ciudadela.appspot.com/o/bg-presentacion.svg?alt=media&token=55d0960d-9024-430d-ba42-31a6a2d51a7f);
            height:100vh;
          }
          .${sfx}-container {
            width: 80%;
            height: 80%;
            border: 1px solid #fff;

          }
          .${sfx}-image {
            width: 80%;
            height: 80%;
            border-right: 1px solid #fff;
            border-bottom: 1px solid #fff;
            float: left;
            padding: 0px 20px;
          }
          .${sfx}-image p {
            color: #fff;
            font-size: 1rem;
            font-family: 'Bebas Neue';
          }
          .${sfx}-description {
            width: 20%;
            height: 80%;
            float: left;
            border-bottom: 1px solid #fff;
            text-align: center;
            padding: 0 20px 20px 20px;
            overflow: hidden;
          }
          .${sfx}-description p {
            color: #fff;
            font-size: 1rem;
            font-family: 'Bebas Neue';
          }
          .${sfx}-bottom-content {
            width: 100%;
            float: left;
            height: 138px;
          }
          .${sfx}-title {
            display: flex;
            width: 80%;
            float: left;
            height: 100%;
            padding: 0 15px;
            align-items: center;
            align-content: center;
          }
          .${sfx}-title h1 {
            color: #fff;
            font-size: 3rem;
            font-family: 'Bebas Neue';
            letter-spacing: 3px;
            margin: 0;
          }
          .${sfx}-cube {
            width: 20%;
            height: 100%;
            background-color: #fff;
            float: left;
          }
        </style>`
          : "";
          this.el.innerHTML = `${style}<div class="${sfx}">
            <div class="${sfx}-container">
              <div class="${sfx}-image">
                ${
                  attrs['presentationImage'] != '' ? `<img src="${attrs['presentationImage']}" />` : ''
                }
                ${
                  attrs['presentationText'] != '' ? `<p>${attrs['presentationText']}</p>` : ''
                }
              </div>
              <div class="${sfx}-description">
                <p>${attrs['presentationDescription']}</p>
              </div>
              <div class="${sfx}-bottom-content">
                <div class="${sfx}-title">
                  <h1>${attrs['presentationTitle']}</h1>
                </div>
                <div class="${sfx}-cube"></div>
              </div>
            </div>
          </div>`;
        },
        events: {
          // If you want to bind the event to children elements
          // 'click .someChildrenClass': 'methodName',
          // click: "handleClick",
          // dblclick: function () {
          //   alert("Hi!");
          // },
        }
      }),
    });

    var blockManager = editor.BlockManager;
    blockManager.add(componentOptions.blocks, {
      label: "Presentación",
      category: "Extra",
      content: {
        content: '',
        editable: !1,
        droppable: !0,
        type: componentOptions.blocks,
        style: {
          width: "100%"
        },
      },
      attributes: { class: "fa-regular fa-window-restore" },
    });
  }
);
